<template>
  <div class="user_list">
    <div class="container">
      <el-card>
        <el-button
          v-has-permission="'/admin_user/v1/add'"
          class="colortheme"
          @click="
            dialogVisible = true
            dialogType = 0
          "
          >+添加用户</el-button
        >
        <div class="table_box">
          <el-table :data="tabaleData" row-key="id" lazy :header-cell-style="cellStyle">
            <el-table-column prop="id" label="编号" width="80" align="center" />
            <el-table-column align="center" label="头像" min-width="100" v-slot="{ row }">
              <el-image v-if="row.userAvatarKey" :src="row.userAvatarKey" @click="itemClick(row)" />
              <el-image v-else-if="row.sex == '男'" :src="man" @click="itemClick(row)" />
              <el-image v-else-if="row.sex == '女'" :src="woman" @click="itemClick(row)" />
            </el-table-column>
            <el-table-column prop="userName" label="姓名" align="center" min-width="100">
              <template v-slot="{ row }">
                <p @click="itemClick(row)">{{ row.userName }}</p>
              </template>
            </el-table-column>
            <el-table-column prop="position" label="职位" align="center" min-width="100">
              <template v-slot="{ row }">
                <!-- <div>{{ positionList[row.position] }}</div> -->
                <div v-for="(item, index) in row.positions" :key="index">
                  <div v-if="item == 0">部门经理</div>
                  <div v-if="item == 1">客户经理</div>
                  <div v-if="item == 2">项目经理</div>
                  <div v-if="item == 3">商务经理</div>
                  <div v-if="item == 4">数据运营</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="userName" label="级别" align="center" min-width="80">
              <template v-slot="{ row }">
                <div v-if="row.rank == 1">顾问</div>
                <div v-else>助理</div>
              </template>
            </el-table-column>

            <el-table-column prop="nameEnglish" label="英文名" align="center" min-width="100" />
            <el-table-column prop="roleName" label="角色" align="center" min-width="100">
              <template v-slot="{ row }">
                <div v-for="(item, index) in row.roleNames" :key="index">{{ item }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="mobile" label="电话" align="center" min-width="140" />
            <el-table-column prop="email" label="邮箱" align="center" min-width="180" />
            <el-table-column prop="weChat" label="微信" align="center" min-width="100" />
            <el-table-column class="operation" min-width="100" label="操作" align="center">
              <template v-slot="{ row }">
                <div class="operation_bottom">
                  <dic-button
                    permission="/admin_user/v1/edit"
                    @buttonClick="editItem(row)"
                    icon="icon-jr-icon-modify"
                    text="编辑"
                  />
                  <dic-button
                    @buttonClick="deleteItem(row)"
                    icon="icon-jr-icon-delete"
                    text="删除"
                    permission="/admin_user/v1/delete"
                  />
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>
    </div>
    <div class="pagination">
      <el-pagination
        :current-page="queryInfo.pageNum"
        :page-sizes="[10, 30, 50]"
        :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <el-dialog
      ref="addVisible"
      :title="dialogType ? '编辑用户' : '新增用户'"
      :visible.sync="dialogVisible"
      width="50%"
      @close="handleClose"
      center
    >
      <el-form
        ref="userObj"
        :model="userObj"
        :rules="userRules"
        label-width="100px"
        :inline="true"
        class="common_from"
      >
        <upload-image :imageUrl.sync="userObj.userAvatar" :imageUrls.sync="userObj.userAvatarKey" />
        <el-form-item label="姓名：" prop="userName">
          <el-input v-model="userObj.userName" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="英文名：" prop="nameEnglish">
          <el-input v-model="userObj.nameEnglish" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="级别：" prop="rank">
          <el-select v-model="userObj.rank" filterable placeholder="请选择">
            <el-option
              v-for="item in rankList"
              :key="item.id"
              :label="item.rankName"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="用户角色：" prop="roleId">
          <el-select v-model="userObj.roleId" filterable placeholder="请选择">
            <el-option
              v-for="item in roleList"
              :key="item.id"
              :label="item.roleName"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="电话：" prop="mobile">
          <el-input v-model="userObj.mobile" placeholder="请输入" maxlength="11" />
        </el-form-item>
        <el-form-item label="微信号：" prop="weChat">
          <el-input v-model="userObj.weChat" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="性别：" prop="sex" style="width: 400px">
          <el-radio-group v-model="userObj.sex">
            <el-radio label="男">男</el-radio>
            <el-radio label="女">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="邮箱：" prop="email">
          <el-input v-model="userObj.email" placeholder="请输入" />
        </el-form-item>

        <el-form-item label="职位：" prop="position">
          <el-select
            v-model="userObj.position"
            filterable
            placeholder="请选择"
            @change="$forceUpdate()"
          >
            <el-option
              v-for="item in positionListTwo"
              :key="item.id"
              :label="item.value"
              :value="item.id"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="入职时间：">
          <el-date-picker
            v-model="userObj.entryTime"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="是否启用：" prop="isStop">
          <el-switch v-model="userObj.isStop" active-color="#4DA75B"> </el-switch>
        </el-form-item>
        <el-form-item label="人才状态：">
          <!-- <div v-if="userObj.isOffice">在职</div>
          <div v-else>已离职</div> -->
          <el-radio-group v-model="userObj.isOffice">
            <el-radio v-model="userObj.isOffice" :label="true">在职</el-radio>
            <el-radio :label="false">离职</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="初始密码：">
          <div>Admin123</div>
        </el-form-item>
        <el-form-item label="离职时间：" v-if="!userObj.isOffice">
          <el-date-picker
            v-model="userObj.leaveTime"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="submitForm">保 存</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { pagination } from '@/mixins/pagination'
import { userList, userAdd, userEdit, detailId, userDelete } from '@/api/user.js'
import { allRoleList } from '@/api/jurisdiction.js'
import DicButton from '../../../components/DicButton.vue'
import UploadImage from '../../../components/UploadImage.vue'
import man from '../../../../static/images/man.png'
import woman from '../../../../static/images/woman.png'
const defaultUserObj = Object.freeze({
  email: '', // 邮箱
  entryTime: '', //入职时间
  leaveTime: '', //离职时间
  isOffice: true, // 是否在职0->在职；1->不在职
  isStop: true, // 是否启用0->启用；1->停用
  mobile: '', // 手机号
  roleId: '', // 角色主键ID
  sex: '', //性别
  userAvatar: '', // 用户头像
  userAvatarKey: '', //展示
  userName: '', // 姓名
  weChat: '', // 微信号
  nameEnglish: '', // 英文姓名
  rank: '', // 级别
  position: ''
})
export default {
  components: { DicButton, UploadImage },
  name: 'userList',
  mixins: [pagination],
  data() {
    return {
      man: man, // 男图片
      woman: woman, // 女图片
      tabaleData: [], //表格数据
      cellStyle: {
        background: '#F7FAF8',
        color: '#1A1F33'
      },
      queryInfo: {
        pageNum: 1,
        pageSize: 10,
        userName: ''
      },
      dialogType: 0, //新增
      dialogVisible: false,
      userObj: { ...defaultUserObj },
      userRules: {
        userName: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        nameEnglish: [{ required: true, message: '请输入英文名', trigger: 'blur' }],
        roleId: [{ required: true, message: '请选择用户角色', trigger: 'change' }],
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        mobile: [
          // { required: true, message: '请输入手机号', trigger: 'blur' },
          // { min: 11, max: 11, message: '请输入正确联系电话', trigger: 'blur' }
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { min: 11, max: 11, message: '请输入正确联系电话', trigger: 'blur' }
          // 这个只能验证手机号
          // { pattern:/^0{0,1}(13[0-9]|15[7-9]|153|156|18[7-9])[0-9]{8}$/, message: "请输入合法手机号", trigger: "blur" }
          // {
          //   pattern: /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/,
          //   message: '请输入合法手机号/电话号',
          //   trigger: 'blur'
          // }
        ],
        sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
        positions: [{ required: true, message: '请选择职位', trigger: 'change' }]
      },
      roleList: [], //角色数组
      rankList: [
        {
          rankName: '顾问',
          id: true
        },
        {
          rankName: '助理',
          id: false
        }
      ], // 角色级别
      // 职位
      positionList: ['部门经理', '客户经理', '项目经理', '商务经理'],
      positionListTwo: [
        {
          value: '部门经理',
          id: '0'
        },
        {
          value: '客户经理',
          id: '1'
        },
        {
          value: '项目经理',
          id: '2'
        },
        {
          value: '商务经理',
          id: '3'
        },
        {
          value: '数据运营',
          id: '4'
        }
      ]
    }
  },
  created() {
    this.search()
    this.searchRole()
  },
  methods: {
    //选中入职时间
    // dateChanged(date) {
    //   console.log(date)
    //   console.log(this.userObj.entryTime)
    // },
    //点击头像进入编辑页
    itemClick(row) {
      this.$router.push({
        path: '/systemManagement/UserInforMation',
        query: { id: row.id }
      })
    },
    //编辑新增保存
    submitForm() {
      this.$refs.userObj.validate(async (valid) => {
        if (valid) {
          let res
          if (this.dialogType) {
            res = await userEdit(this.userObj)
          } else {
            res = await userAdd(this.userObj)
            // if(res.resultCode == 500){
            //   this.$message.error(res.message)
            // }
          }
          if (res.data.resultCode === 200) {
            this.$message.success(`${this.dialogType ? '编辑' : '新增'}成功`)
            this.search()
          } else {
            this.$message.error(res.message)
          }
          this.dialogVisible = false
        }
      })
    },
    //获取所有角色数据
    async searchRole() {
      const { data: res } = await allRoleList()
      if (res.resultCode === 200) {
        this.roleList = res.data
      }
    },
    // 弹窗关闭
    handleClose() {
      this.$refs.userObj.resetFields()
      Object.assign(this.userObj, defaultUserObj)
      this.dialogVisible = false
    },
    //编辑
    async editItem(row) {
      const { data: res } = await detailId({ id: row.id })
      if (res.resultCode === 200) {
        // console.log("数据",res.data)
        Object.assign(this.userObj, res.data)
        res.data.isOffice ? (this.userObj.isOffice = true) : (this.userObj.isOffice = false)
        this.dialogVisible = true
        this.dialogType = 1
      }
    },
    //删除
    deleteItem(row) {
      this.$confirm('确认删除吗 ?', '提示')
        .then(async () => {
          const { data: res } = await userDelete({ id: row.id })
          if (res.resultCode === 200) {
            this.$message.success('删除成功')
            this.search()
          }
        })
        .catch(() => {})
    },
    //新增
    // addUser() {
    //   console.log('新增')
    // },
    // changeAddProject() {
    //   console.log(this.userObj.positions)
    // },
    handleSizeChange(val) {
      this.queryInfo.pageSize = val
      this.search()
    },
    handleCurrentChange(val) {
      this.queryInfo.pageNum = val
      this.search()
    },
    //查询
    async search() {
      const { data: res } = await userList(this.queryInfo)
      if (res.resultCode === 200) {
        this.tabaleData = res.data.list
        this.total = res.data.total
        // console.log("表格数据",this.tabaleData)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  height: calc(100% - 32px);

  .el-card {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    ::v-deep .el-card__body {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
    }
    .table_box {
      width: calc(100% - 40px);
      height: 100%;
      padding-top: 16px;
      box-sizing: border-box;
      overflow: scroll;
    }
  }
}
.pagination {
  background-color: #fff;
  width: 100%;
  text-align: center;
  margin: 10px 0 20px 0;
}
.user_list {
  width: 100%;
  .el-table {
    /deep/tbody tr:hover > td {
      // background-color: #90c0f1;
      background-color: rgba(23, 117, 122, 0.1);
    }
  }

  /deep/ input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  /deep/[type='number'] {
    -moz-appearance: textfield;
  }
  /deep/ .el-form-item {
    margin-right: 0 !important;
    width: 50% !important;
  }

  .common_from {
    /deep/ .el-input__inner {
      width: 196px;
    }
  }

  /deep/ p {
    cursor: pointer;
  }

  /deep/ .el-image {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    cursor: pointer;
  }
  /deep/ .colortheme {
    background-color: #17757a;
    color: #fff;
    border: 1px solid #17757a;
  }

  /deep/ .el-table::before {
    height: 0;
  }

  /deep/ .el-table__cell {
    border: none;
  }
}
</style>
